package com.example.monetix.utils

import kotlinx.browser.document
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.Image
import org.w3c.files.FileReader
import org.w3c.files.get
import kotlin.coroutines.resume

suspend fun pickAndCompressImageAsBase64(maxSize: Double = 1280.0, quality: Double = 0.75): String? = suspendCancellableCoroutine { continuation ->
    // 1. Creiamo un "tasto scegli file" invisibile
    val input = document.createElement("input") as HTMLInputElement
    input.type = "file"
    input.accept = "image/png, image/jpeg, image/webp"

    // 2. Cosa succede quando l'utente sceglie la foto
    input.onchange = {
        val file = input.files?.get(0)
        if (file != null) {
            val reader = FileReader()
            reader.onload = { event ->
                val img = Image()
                img.onload = {
                    val width = img.width.toDouble()
                    val height = img.height.toDouble()

                    val scale = minOf(1.0, minOf(maxSize / width, maxSize / height))
                    val targetWidth = (width * scale).coerceAtLeast(1.0)
                    val targetHeight = (height * scale).coerceAtLeast(1.0)

                    // 4. Disegniamo l'immagine su un Canvas in alta risoluzione
                    val canvas = document.createElement("canvas") as HTMLCanvasElement
                    canvas.width = targetWidth.toInt()
                    canvas.height = targetHeight.toInt()
                    val ctx = canvas.getContext("2d") as CanvasRenderingContext2D
                    ctx.drawImage(img, 0.0, 0.0, targetWidth, targetHeight)

                    // 5. ESPORTAZIONE AD ALTA QUALITÀ (JPEG 85%)
                    val base64String = canvas.toDataURL("image/jpeg", quality)

                    continuation.resume(base64String)
                }
                // Carica l'immagine nel tag img nascosto
                img.src = event.target.asDynamic().result as String
            }
            reader.readAsDataURL(file)
        } else {
            // L'utente ha chiuso la finestra senza scegliere nulla
            continuation.resume(null)
        }
    }

    // Simuliamo il click per far aprire la cartella del PC/Telefono
    input.click()
}